module.exports = __webpack_public_path__ + "static/img/file_open.fb1d0478.png";